module.exports = __webpack_public_path__ + "57fa48a3de992624af696e3b6370c96b.MP3";